import {Helmet} from '@dr.pogodin/react-helmet';

import {InspectionType} from '@dms/api/core';
import i18n from '@dms/i18n';

import {InspectionsDetail} from '../InspectionsDetail/InspectionsDetail';

export function HandoverInspection() {
  return (
    <>
      <Helmet title={i18n.t('entity.vehicle.labels.handOverInspection')} />
      <InspectionsDetail inspectionType={InspectionType.HANDOVER} />
    </>
  );
}
